import React from "react";
import { Menu } from "lucide-react";

const MobileNavbar = ({ onMenuClick, title }) => {
  return (
    <div className="md:hidden fixed top-0 left-0 w-full h-16 bg-white border-b border-gray-200 shadow-md flex items-center px-4 z-40">
      <button 
        onClick={onMenuClick} 
        className="mr-4 p-2 hover:bg-gray-100 rounded-lg transition-colors duration-200 active:bg-gray-200"
      >
        <Menu className="w-6 h-6 text-gray-800" strokeWidth={2.5} />
      </button>

      <h1 className="text-lg font-bold text-gray-900 truncate">
        {title || "Star Nutrition"}
      </h1>
    </div>
  );
};

export default MobileNavbar;
